import { useApi } from '@/composables'
import http from '../composables/src/useHttp'

export const getCommentsByTicket = (ticketId: string) => {
  return useApi(http.get(`/tickets/${ticketId}/comments`, { params: { ticketId } }))
}

export const createComment = (ticketId: string, commentData: { content: string; isPrivate: boolean; createdBy: string }) => {
  return useApi(
    http.post(`/tickets/${ticketId}/comments`, commentData, {
      headers: { 'Content-Type': 'application/json' },
    }),
  )
}

export const deleteComment = (ticketId: string, commentId: string) => {
  return useApi(http.delete(`/tickets/${ticketId}/comments/${commentId}`))
}

export const updateComments = (ticketId: string, commentId: string, commentData: { content: string }) => {
  return useApi(
    http.patch(`/tickets/${ticketId}/comments/${commentId}`, commentData, {
      headers: { 'Content-Type': 'application/json' },
    }),
  )
}
